<template>
  <div class="helper-view">
    <div v-if="genericError || icon" :class="computedInitialAvatarIconClass">
      <InitialAvatarIcon :icon="headerInfo.icon" size="large" />
    </div>
    <div class="helper-view__title">
      <Heading as="p" :level="3">{{ headerInfo.title }}</Heading>
    </div>
    <div class="helper-view__description">
      <BaseText size="md" :color="NebraskaColors.elementSecondary">
        {{ headerInfo.description }}
      </BaseText>

      <BaseText
        v-if="genericError"
        size="md"
        :color="NebraskaColors.elementSecondary"
        data-testid="helpertext"
        class="helper-view__helpertext"
      >
        Se persistir, fale com a gente pelo e-mail
        <Link href="mailto:meajuda@warren.com.br">meajuda@warren.com.br</Link>
        ou pelo
        <Link href="https://wa.me/555140420024" target="_blank">Whatsapp.</Link>
      </BaseText>
    </div>
    <div v-if="buttonLabel" class="helper-view__button">
      <ButtonSecondary
        v-if="buttonSecondary"
        :label="buttonLabel"
        :disabled="buttonDisabled"
        :loading="buttonLoading"
        @click="helperViewButtonEvent"
      />
      <ButtonPrimary
        v-else
        :label="buttonLabel"
        :disabled="buttonDisabled"
        :loading="buttonLoading"
        @click="helperViewButtonEvent"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { InitialAvatarIcon } from '@/components/initial-avatar';
import { Heading } from '@/components/heading';
import { BaseText } from '@/components/base-text';
import { ButtonPrimary, ButtonSecondary } from '@/components/button';
import { Link } from '@/components/link';

@Component({
  name: 'HelperViewFoundation',
  components: {
    Heading,
    InitialAvatarIcon,
    BaseText,
    ButtonPrimary,
    ButtonSecondary,
    Link
  }
})
export default class HelperViewFoundation extends Vue {
  /**
   * Ícone a ser exibido no componnte
   */
  @Prop({ type: String, required: false })
  readonly icon?: string;

  /**
   * O título principal do componente
   */
  @Prop({ type: String, required: false })
  readonly title?: string;

  /**
   * O texto de apoio do componente
   */
  @Prop({ type: String, required: false })
  readonly description?: string;

  /**
   * Label do botão de ação
   */
  @Prop({ type: String, required: false })
  readonly buttonLabel?: string;

  /**
   * Habilita ou desabilita o botão de ação
   */
  @Prop({ type: Boolean, default: false })
  readonly buttonDisabled!: boolean;

  /**
   * Coloca o botão no estado de carregamento
   */
  @Prop({ type: Boolean, default: false })
  readonly buttonLoading!: boolean;

  /**
   * Define o botão como secundário
   */
  @Prop({ type: Boolean, default: false })
  readonly buttonSecondary!: boolean;

  readonly NebraskaColors = NebraskaColors;

  /**
   * Define se vai trocar o descripion pelo erro genérico "Se o problema persistir, etc..."
   */
  @Prop({ type: Boolean, default: false })
  readonly genericError!: boolean;

  /**
   * Evento de click do botão, quando existente
   */
  @Emit('click')
  private helperViewButtonEvent() {
    // Função que emite evento click
  }

  get computedInitialAvatarIconClass() {
    return {
      'helper-view__icon': true,
      'helper-view__icon--error': this.genericError
    };
  }

  get headerInfo() {
    return this.genericError
      ? {
          icon: 'EF0062',
          title: 'Algo deu errado',
          description: 'Espere alguns instantes e tente novamente.'
        }
      : {
          icon: this.icon,
          title: this.title,
          description: this.description
        };
  }
}
</script>

<style lang="less" scoped>
.helper-view {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 368px;

  &__icon {
    margin-bottom: @size-spacing-x400;

    &--error {
      ::v-deep .initial-avatar-icon {
        background: @status-alert-background !important;
        color: @status-alert !important;
      }
    }
  }

  &__title {
    margin-bottom: @size-spacing-x300;
  }

  &__button {
    margin-top: @size-spacing-x400;
  }

  &__helpertext {
    margin-top: @size-spacing-x500;

    a {
      font-weight: 400;
    }
  }
}
</style>
